import TimeIcon from "@mui/icons-material/AccessTimeRounded";
import CancelIcon from "@mui/icons-material/CancelRounded";
import CheckIcon from "@mui/icons-material/CheckCircleRounded";
import CircleIcon from "@mui/icons-material/RadioButtonUncheckedRounded";
import SkippedIcon from "@mui/icons-material/RemoveCircleRounded";
import { CircularProgress } from "@mui/material";
import { orange } from "@mui/material/colors";
import type { WorkflowActivity } from "../../../../../api/types/workflowTypes";

interface Props {
  activity: WorkflowActivity;
}

const WorkflowActivityTimelineIcon = ({ activity }: Props) => {
  if (activity.executionPhase === "Initializing" || activity.executionPhase === "Executing") {
    return <CircularProgress size={20} color="secondary" />;
  }

  const isSkipped = activity.state === "Completed" && activity.completionKind === "Skipped";

  switch (activity.state) {
    case "None":
      return <CircleIcon color="secondary" />;
    case "WaitingForSignal":
      return <TimeIcon sx={{ color: orange[700] }} />;
    case "Completed":
      if (isSkipped) {
        return <SkippedIcon color="disabled" />;
      }
      return <CheckIcon color="success" />;
    case "Cancelled":
      return <CancelIcon color="secondary" />;
    default:
      return <CircleIcon color="secondary" />;
  }
};

export default WorkflowActivityTimelineIcon;
